module.exports = __webpack_public_path__ + "img/courses-1.20527d16.jpg";